var _path, _rect, _polygon, _path2, _path3, _rect2, _rect3, _rect4, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalizacion2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24,131.53v23.35c0,3.42,2.79,6.21,6.21,6.21h180.81c3.25,0,5.89-2.64,5.89-5.89v-23.68H4.24z M194.58,155.21   c0,1.83-1.49,3.32-3.32,3.32H10.45c-2.01,0-3.64-1.63-3.64-3.64V134.1h187.76V155.21z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.1,
    y: 124.96,
    width: 131.5,
    height: 2.57
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "163.93,34.39 167.92,40.63 42.68,120.31 44.06,122.48 171.48,41.41 164.71,30.85 28.52,117.51 29.9,119.68  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.29,170.65c0,0.57-0.46,1.03-1.03,1.03H22.32c-0.57,0-1.03-0.46-1.03-1.03v-4.02h-2.57v4.02c0,1.99,1.62,3.6,3.6,3.6   h10.94c1.98,0,3.6-1.61,3.6-3.6v-4.02h-2.57V170.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.64,170.65c0,0.57-0.46,1.03-1.03,1.03h-10.94c-0.57,0-1.03-0.46-1.03-1.03v-4.02h-2.57v4.02c0,1.99,1.61,3.6,3.6,3.6   h10.94c1.98,0,3.6-1.61,3.6-3.6v-4.02h-2.57V170.65z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.74,
    y: 142.85,
    width: 2.57,
    height: 5.88
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 143.2,
    width: 2.57,
    height: 5.88
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7,
    y: 143.2,
    width: 2.57,
    height: 6.23
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.06,121.3c3.49,0,6.33,2.84,6.33,6.33h2.57c0-4.91-3.99-8.9-8.9-8.9s-8.9,3.99-8.9,8.9h2.57   C13.74,124.14,16.58,121.3,20.06,121.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalizacion2);
export default __webpack_public_path__ + "static/media/digitalizacion2.3d4980f932824d6dc5b6e37c1797e8ab.svg";
export { ForwardRef as ReactComponent };